import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function DiagnosticSection() {
  const [checkedItems, setCheckedItems] = useState<Record<number, boolean>>({});
  const questions = ['¿Te cuesta más de 30 minutos dormirte?', '¿Te despiertas varias veces por la noche?', '¿Tienes neblina mental durante el día?', '¿Tienes más hambre de dulce que antes?'];
  const toggleCheck = (index: number) => {
    setCheckedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const checkedCount = Object.values(checkedItems).filter(Boolean).length;
  return <section className="py-24 bg-cream-alt relative" data-id="element-44">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-45">
        <FadeIn data-id="element-46">
          <div className="text-center mb-12" data-id="element-47">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-48">
              Responde esto:
            </h2>
            <p className="text-charcoal-light text-lg" data-id="element-49">
              Selecciona las situaciones que vives actualmente
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-50">
          {questions.map((question, index) => {
          const isChecked = checkedItems[index] || false;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-51">
                <button onClick={() => toggleCheck(index)} className={`w-full text-left p-6 rounded-2xl border-2 transition-all duration-300 flex items-center gap-6 group
                    ${isChecked ? 'bg-white border-terracotta shadow-warm-md' : 'bg-white/50 border-transparent hover:bg-white hover:shadow-card'}`} data-id="element-52">
                  <div className={`flex-shrink-0 w-8 h-8 rounded-lg border-2 flex items-center justify-center transition-colors
                    ${isChecked ? 'bg-terracotta border-terracotta' : 'border-charcoal-muted group-hover:border-terracotta/50'}`} data-id="element-53">
                    {isChecked && <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-54" />}
                  </div>
                  <span className={`text-lg md:text-xl font-medium transition-colors
                    ${isChecked ? 'text-charcoal' : 'text-charcoal-light'}`} data-id="element-55">
                    {question}
                  </span>
                </button>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.4} data-id="element-56">
          <div className={`text-center transition-all duration-500 transform
            ${checkedCount > 0 ? 'opacity-100 translate-y-0' : 'opacity-50 translate-y-4'}`} data-id="element-57">
            <div className="inline-block bg-white px-8 py-6 rounded-2xl shadow-card border border-terracotta/20" data-id="element-58">
              <p className="text-xl md:text-2xl font-serif font-bold text-terracotta-dark" data-id="element-59">
                Si respondiste "sí" a varias… esto es EXACTAMENTE lo que
                necesitas.
              </p>
              <p className="mt-4 text-base md:text-lg text-charcoal-light font-medium" data-id="element-60">
                No necesitas más fuerza de voluntad.{' '}
                <span className="font-bold text-charcoal" data-id="element-61">
                  Necesitas el sistema correcto.
                </span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}